const validate = (values) => {
    const errors = {};    
    if (!values.behaviorsReductionId) {
        errors.behaviorsReductionId = 'Please select behavior name';
    }
    return errors;
};
export default validate;




// WEBPACK FOOTER //
// ./src/modules/patients/components/DataAnalyticsBehaviors/validate.js